import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface ProfileIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Profile icon using SF Pro font symbol (􀉪)
 *
 * This icon represents user profile/account in the ANYW3AR app.
 *
 * @example
 * ```tsx
 * <ProfileIcon />
 * <ProfileIcon size={16} weight="semibold" />
 * ```
 */
export const ProfileIcon = React.forwardRef<HTMLSpanElement, ProfileIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀉪" {...props} />
  }
)

ProfileIcon.displayName = "ProfileIcon"